import { soFarDate } from '../../utils'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}

	const { order, injured, setting } = this
	let list =
		injured.hospitalInfo && injured.hospitalInfo.length
			? injured.hospitalInfo
			: [{}]
	const subsequentVisit = injured.subsequentVisit || ''
	let arr = []

	for (const [index, item] of list.entries()) {
		arr = arr.concat([
			{
				label: `就诊医院(第${index + 1}次住院)`,
				value: item.hospital,
				key: 'hospital',
			},
			{ label: '就诊科室', value: item.department, key: 'department' },
			{
				label: '入院日期',
				value: soFarDate(item.beginTime),
				key: 'beginTime',
			},
			{
				label: '出院日期',
				value: soFarDate(item.endTime),
				key: 'endTime',
			},
		])
	}

	arr.push({
		label: '有复诊',
		value: setting.yesNoMap[subsequentVisit.hasVisit],
		key: 'hasVisit',
	})

	if (subsequentVisit.hasVisit === '1') {
		arr = arr.concat([
			{
				label: '最后一次复诊时间',
				value: soFarDate(subsequentVisit.visitTime),
				key: 'visitTime',
			},
			{ label: '复诊医院', value: subsequentVisit.hospital, key: 'hospital' },
			{
				label: '复诊科室',
				value: subsequentVisit.department,
				key: 'department',
			},
			{
				label: '有门诊复诊病历',
				value: setting.yesNoMap[subsequentVisit.medicalRecord],
				key: 'medicalRecord',
			},
		])
	}

	return {
		title: '住院信息',
		children: arr,
	}
}
